import { BrandEnum } from "../_common/enum/brand.enum";
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "quoteComparison";

export const quoteComparisonService = {
    getQuotes,
    getMortgageQuotes,
};

function getQuotes(formId: number, brand: BrandEnum) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetQuotes/?formId=${formId}&brand=${brand}`, requestOptions).then(handleResponse);
}

function getMortgageQuotes(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getMortgageQuotes?${getQuery(query)}`, requestOptions).then(handleResponse);
}

